import React, { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Chip } from "@/components/Shared";
import { toast } from "sonner";

export default function SlotHistoryDialog({ open, onOpenChange, slot }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open || !slot) return;
        setLoading(true);
        api.get(`/parking/slots/${slot.id}/allocations`)
            .then((res) => setRows(res.data || []))
            .catch((e) => toast.error(formatError(e)))
            .finally(() => setLoading(false));
    }, [open, slot]);

    if (!slot) return null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="rounded-sm max-h-[85vh] overflow-y-auto sm:max-w-2xl">
                <DialogHeader>
                    <DialogTitle className="font-heading text-2xl tracking-tight">Allocation history — {slot.slot_number}</DialogTitle>
                </DialogHeader>
                {loading ? (
                    <p className="text-sm text-brand-inkSoft py-6 text-center">Loading…</p>
                ) : rows.length === 0 ? (
                    <p className="text-sm text-brand-inkSoft py-6 text-center">No allocation history for this slot yet.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm" data-testid="slot-history-table">
                            <thead>
                                <tr className="text-left text-[10px] uppercase tracking-overline text-brand-inkSoft border-b border-brand-line">
                                    <th className="py-2 pr-3">Flat</th>
                                    <th className="py-2 pr-3">Start</th>
                                    <th className="py-2 pr-3">End</th>
                                    <th className="py-2 pr-3">Status</th>
                                    <th className="py-2 pr-3">Charging</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id} className="border-b border-brand-line/60" data-testid={`slot-history-row-${r.id}`}>
                                        <td className="py-2 pr-3 font-medium text-brand-ink">{r.flat ? `${r.flat.block}-${r.flat.number}` : "—"}</td>
                                        <td className="py-2 pr-3">{r.start_date || "—"}</td>
                                        <td className="py-2 pr-3">{r.end_date || "—"}</td>
                                        <td className="py-2 pr-3"><Chip variant={r.status === "active" ? "success" : "neutral"}>{r.status}</Chip></td>
                                        <td className="py-2 pr-3">{r.charging_enabled ? `₹${r.charge_amount} / ${(r.frequency || "").replace("_", " ")}` : "Free"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
